import axiosInstance from '../utils/axios'

export const apiClient = axiosInstance

// Función para crear instancias personalizadas (si es necesario en el futuro)
// Por ahora, todas usan la misma instancia con tokenManager
import type { AxiosInstance, AxiosRequestConfig } from 'axios'

export const createCustomApiClient = (customConfig?: AxiosRequestConfig): AxiosInstance => {
  // Si necesitas una instancia personalizada, puedes crearla aquí
  // Pero por defecto, usa la misma instancia con tokenManager
  return axiosInstance
}

export default apiClient
